/* eslint react/prefer-stateless-function: "off",  */

import React from 'react';
import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import PropTypes from 'prop-types';

export default class Navigation extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
  };

  render() {
    return (
      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>Vince: {window.genesisSettings.appEnvironment} environment</Navbar.Brand>
        </Navbar.Header>
        <Nav>
          <NavItem href="/" active={this.props.location.pathname === '/'}>
            Index
          </NavItem>
          <NavItem href="/dealership-list" active={this.props.location.pathname === '/dealership-list'}>
            Dealership List
          </NavItem>
        </Nav>
        <Nav pullRight>
          <NavItem href="/logout">Logout</NavItem>
        </Nav>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation.js